import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppKitAccount } from "@reown/appkit/react";

const SIGNATURE_MAX_AGE_MS = 2 * 60 * 60 * 1000; // 2 hours

function isSignatureValidForAddress(address) {
  if (!address) return false;
  try {
    const raw = localStorage.getItem(address);
    if (!raw) return false;
    const { signature, message, timestamp } = JSON.parse(raw);
    if (!signature || !message) return false;
    const ts = Number(timestamp);
    if (!Number.isFinite(ts)) return true;
    return Date.now() - ts < SIGNATURE_MAX_AGE_MS;
  } catch (_) {
    return false;
  }
}

const AuthorizedComponent = ({ children }) => {
  const { address, isConnected } = useAppKitAccount();
  const [checked, setChecked] = useState(false);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const ok = isConnected && isSignatureValidForAddress(address);
    setAuthorized(ok);
    setChecked(true);
  }, [address, isConnected]);

  if (!checked) return null;
  // If wallet not connected, go to login
  if (!isConnected) return <Navigate to="/login" />;
  // If wallet connected but signature not yet valid, stay on page.
  // WalletInfo will prompt for signature and block UI until completed.
  return children;
};

export default AuthorizedComponent;
